module.exports = __webpack_public_path__ + "img/blog6.c91fb055.jpeg";